import { DOCUMENT, Location } from '@angular/common';
import { Injectable, Injector } from '@angular/core';

@Injectable()
export class LocationService {
  doc;
  host;
  constructor(private injector: Injector, private location: Location) {
    this.doc = this.injector.get(DOCUMENT);
    this.host = this.doc.location.protocol + '//' + this.doc.location.hostname;
  }

  get currentUrl(): string {
    return this.host + this.location.path();
  }

  getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(this.currentUrl);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
}
